import handler from './handlers/axios';

const apiClient = handler.create({
  baseURL: window.backendConfig.jct.base_url,
  headers: {
    Authorization: `Bearer ${document.head.querySelector('[name="jwt-token"]').content}`,
  },
});

export default apiClient;
